// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AL3I","toggleWrap":"styles_toggleWrap__2e9g-","content":"styles_content__2h0Nb","selectAreaCode":"styles_selectAreaCode__2IynJ"};